<template>
  <div>
    <van-tab :title="activityStatusTitle">
      <Roster ref="rank"
        v-if="activityStatus === 3 || activityStatus === 4"
        :activityStatus="activityStatus"
        type="component"
        :isLogin="isLogin"
      />
      <div class="container" ref="ranking" v-else>
        <div class="pullup">
          <div ref="scroll" class="pullup-wrapper">
            <div class="no-data tip">
              <div>各期评审结果汇总中  请耐心等待</div>
            </div>
          </div>
        </div>
      </div>
    </van-tab>
  </div>
</template>
<script>
import Roster from './roster'

export default {
  props: {
    activityAllInfo: {
      type: Object,
      required: true
    },
    isLogin: {
      type: Boolean
    }
  },
  components: {
    Roster
  },
  watch: {
    isLogin(val) {
      console.log('iislogin', val)
      if (val) {
        this.isLogin = val
      }
    }
  },
  computed: {
    // 复选结果出来才展示
    isShowRank() {
      return this.activityAllInfo.activityInfo.activity_status !== 2
    },
    activityStatus() {
      return this.activityAllInfo.activityInfo.activity_status
    },
    activityStatusTitle() {
      return this.activityStatus === 4 ? '决胜名单' : '复选名单'
    }
  }
}
</script>
<style lang="less" scoped>
.loading-wrapper {
  position: relative;
  // padding: 10px 0 40px;

  .loading-clone {
    visibility: hidden;
  }

  .tip {
    width: 100%;
    margin: 10px 0 15px;
    text-align: center;
    color: #999;
  }
}

.no-data {
  position: relative;
  height: 150px;
  margin: 200px/2 auto;
  text-align: center;
  color: #999;
  background: url(../../../../assets/images/home/no_data.png) top center no-repeat;
  background-size: 100px 100px;
  pointer-events: none !important;

  > div {
    position: absolute;
    top: 73%;
    width: 100%;
    font-size: 26px/2;
    text-align: center;
    color: #666;
  }
}
</style>
